module.exports = __webpack_public_path__ + "static/media/buildingConstruction39.750d6b6c.jpg";